import { EyeInvisibleOutlined } from '@ant-design/icons';
import { useStore } from '../../store/store';

// Bannière persistante tant que l'opportunité (ou l'offre) du document est
// cachée : une fois l'éditeur fermé, le document n'est plus listé nulle part.
// Placée en bas pour ne pas chevaucher les bannières collab (top: 64).
export const HiddenDocumentBanner = () => {
  const hidden = useStore(({ documentIdentity }) => !!documentIdentity?.hidden);
  const isOffer = useStore(({ currentDocument }) => currentDocument.type === 'offer');

  if (!hidden) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2000,
        backgroundColor: '#d4380d',
        color: '#fff',
        padding: '8px 16px',
        borderRadius: 4,
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        maxWidth: 'calc(100vw - 32px)',
      }}
    >
      <EyeInvisibleOutlined />
      <span>
        Attention : {isOffer ? "L'offre associée" : "L'opportunité associée"} à ce
        document est cachée et il vous est impossible de le retrouver depuis
        votre interface. Votre administrateur peut réafficher{' '}
        {isOffer ? 'votre offre' : 'votre opportunité'} si nécessaire.
      </span>
    </div>
  );
};

export default HiddenDocumentBanner;
